/**
 * Orchestra AI Platform - Server Badge Component
 * 
 * Badge component for displaying AI server type with design system colors
 * 
 * @fileoverview Server badge with color coding from design tokens
 */

import PropTypes from 'prop-types';
import { colors } from '../../design-system/tokens';
import './ServerBadge.css';

const serverConfig = {
  chinese: {
    label: 'Chinese AI',
    color: colors.chinese[500],
    bgColor: colors.chinese[50],
    icon: '🇨🇳',
  },
  english: {
    label: 'English AI',
    color: colors.english[500],
    bgColor: colors.english[50],
    icon: '🇬🇧',
  },
  maths: {
    label: 'Math AI',
    color: colors.maths[500],
    bgColor: colors.maths[50],
    icon: '🔢',
  },
  myclass: {
    label: 'MyClass AI',
    color: colors.myclass[500],
    bgColor: colors.myclass[50],
    icon: '🎓',
  },
};

/**
 * Server Badge Component
 * @param {Object} props
 * @param {('chinese'|'english'|'maths'|'myclass')} props.server - Server type
 * @param {('sm'|'md'|'lg')} [props.size='md'] - Badge size
 * @param {boolean} [props.showIcon=true] - Show icon
 */
export function ServerBadge({ server, size = 'md', showIcon = true }) {
  const config = serverConfig[server] || serverConfig.chinese;

  return (
    <span
      className={`server-badge server-badge-${size}`}
      style={{
        backgroundColor: config.bgColor,
        color: config.color,
      }}
      aria-label={`${config.label} server`}
    >
      {showIcon && <span className="server-badge-icon" aria-hidden="true">{config.icon}</span>}
      <span>{config.label}</span>
    </span>
  );
}

ServerBadge.propTypes = {
  server: PropTypes.oneOf(['chinese', 'english', 'maths', 'myclass']).isRequired,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  showIcon: PropTypes.bool,
};

